"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AsyncSelectTranslations = {
    fi: {
        AsyncSelect: {
            loading: 'Lataa...',
            placeholder: 'Valitse...',
        },
    },
    en: {
        AsyncSelect: {
            loading: 'Loading...',
            placeholder: 'Select...',
        },
    },
};
exports.default = AsyncSelectTranslations;
//# sourceMappingURL=AsyncSelect.translation.js.map